import { CoverImageContainer } from "./CoverImageContainer";
import { CoverImageFormPortal } from "./CoverImageFormPortal";
import { useEditHomeCover } from "./useEditCoverImages";

export const HomeCoverForm = () => {
  const {
    coverImage,
    hasCoverImage,
    isAdmin,
    isLoading,
    isSmallScreen,
    onDelete,
    onSubmit,
  } = useEditHomeCover();

  return (
    <>
      <CoverImageContainer />
      <CoverImageFormPortal
        coverImage={coverImage}
        enabled={hasCoverImage}
        isLoading={isLoading}
        isMobile={isSmallScreen}
        onDelete={onDelete}
        onSubmit={onSubmit}
        showForm={isAdmin}
      />
    </>
  );
};
